export default "__VITE_ASSET__bcgMVjQr__"